// VERIFIE 04/11/2024 !!!!! Section non vérifié plus bas

// ||
// ||
// \/

import { Vehicule } from "../interfaces";
import { ObjectId } from "../types";
import { ip } from "../utils/setup";

const VEHICULE_API = `${ip}/api/Vehicules`;



// GET

export async function getVehiculesNoHiden() {
  try {
      const response = await fetch(VEHICULE_API + "/noHiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getVehiculesHiden() {
  try {
      const response = await fetch(VEHICULE_API + "/Hiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getVehAssAlert(): Promise<Vehicule[]> {
  try {
      const response = await fetch(VEHICULE_API + "/AssAlert", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getVehCTAlert(): Promise<Vehicule[]> {
  try {
      const response = await fetch(VEHICULE_API + "/CtAlert", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

export async function getVehicule(_id: ObjectId): Promise<Vehicule> {
    const response = await fetch(`${VEHICULE_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la r�ception du v�hicule");
  }
}

// POST

export async function createVehicule(
  newVehicule: Partial<Vehicule>
): Promise<Vehicule> {
  const response = await fetch(VEHICULE_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(newVehicule),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau véhicule");
  }
}

// PUT

export async function updateVehicule(updateVehicule: Vehicule) {
  const { globalError, ...restVehicule } = updateVehicule;
  const response = await fetch(`${VEHICULE_API}/${restVehicule.idCar}`, {
      method: "PUT",
      credentials: "include" ,
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify(restVehicule),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du véhicule");
  }
}

// DELETE

export async function deleteVehicule(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${VEHICULE_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression du véhicule ");
  }
}

// NON VERIFIE !!!!!

// ||
// ||
// \/

//export async function getVehicules(): Promise<Vehicule[]> {
//  const response = await fetch(VEHICULE_API);
//  if (response.ok) {
//    const body: Vehicule[] = await response.json();
//    return body;
//  } else {
//    return response.json();
//  }
//}
